module.exports = __webpack_public_path__ + "img/ep-rectangle-festonne.c821ae3c.jpg";